import React from "react";

const EmployeeServiceRoute = ({ children }) => {
    return children;
};

export default EmployeeServiceRoute;
